// control-center/src/components/credentials/RevokePatDialog.tsx
import { useState } from 'react';

export interface RevokePatDialogProps {
  botName: string;
  patName: string;
  onConfirm: (patName: string) => Promise<void>;
  onCancel: () => void;
}

export function RevokePatDialog({ botName, patName, onConfirm, onCancel }: RevokePatDialogProps) {
  const [pending, setPending] = useState(false);

  const handleConfirm = async () => {
    setPending(true);
    try {
      await onConfirm(patName);
    } finally {
      setPending(false);
    }
  };

  return (
    <div role="dialog" aria-modal="true" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
      <div style={{ background: '#1e293b', color: '#e2e8f0', borderRadius: 8, padding: '1.5rem', maxWidth: 400, width: '100%' }}>
        <h3 style={{ color: '#f87171', marginTop: 0 }}>Revoke PAT?</h3>
        <p style={{ color: '#94a3b8', fontSize: '0.875rem' }}>
          This will permanently revoke <strong>{patName}</strong> from <strong>{botName}</strong>.
          Any systems using this token will lose access immediately.
        </p>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button onClick={onCancel} disabled={pending} style={{ background: '#374151', color: '#d1d5db', border: 'none', borderRadius: 4, padding: '0.4rem 1rem', cursor: 'pointer' }}>Cancel</button>
          <button onClick={handleConfirm} disabled={pending} style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '0.4rem 1rem', cursor: 'pointer' }}>
            {pending ? 'Revoking...' : 'Revoke'}
          </button>
        </div>
      </div>
    </div>
  );
}
